import './App.css';
import TaskPlanner from './components/TaskPlanner';

function App() {
  return (
    <div className="App">
      <TaskPlanner />
    </div>
  );
}

export default App;